// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__F3j2r","content":"Content_content__3uq0E","itemContainer":"Content_itemContainer__2Ukeg"};